import React from 'react';
import Reveal from './atoms/reveal';

const ACCOUNTS = [
  { icon: 'fa-twitter', href: 'http://twitter.com/koneko59', label: 'Twitter', sub: '@koneko59' },
  { icon: 'fa-github', href: 'https://github.com/Tiger59', label: 'GitHub' },
  { icon: 'fa-facebook', href: 'https://www.facebook.com/taiga.kishimoto.14', label: 'Facebook' },
  { icon: 'fa-threads', href: 'https://www.threads.net/@tigre.qui.rit', label: 'Threads' },
];

function SocialMedia() {
  return (
    <section id="socialmedia" className="home-section parallax text-center py-10" data-stellar-background-ratio="0.5">
      <div className="flex items-center justify-center py-5">
        <div className="container relative z-30">
          <Reveal className="section-heading text-center">
            <h2 className="text-4xl text-center font-semibold pb-6">Social Media</h2>
          </Reveal>

          <div className="container grid grid-cols-2 sm:grid-cols-4 xl:px-40">
            {ACCOUNTS.map((account, i) => (
              // hadaka.jp の socialbar と同じく、ひとつずつ弾んで出てくる
              <Reveal key={account.label} variant="pop" delay={i * 100} className="col-span-1">
                <div className="bounce-hover align-center txt-shadow py-4">
                  <div className="icon">
                    <a href={account.href} target="_blank" rel="noopener noreferrer" aria-label={account.label}>
                      <i className={`fa fa-brands ${account.icon} fa-5x`}></i>
                    </a>
                  </div>
                  <span className="color-white">
                    {account.label}
                    {account.sub && (<><br />{account.sub}</>)}
                  </span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>

    </section>
  );
}
export default SocialMedia;
